/**
 * useGoBack
 *
 * Returns a stable callback that pops one entry off the browser
 * history (mirroring the back arrow in a browser). Used by every
 * in-app "back" chevron — collection detail, smart collection,
 * group view — so they all walk the navigation stack instead of
 * jumping to a hard-coded landing page.
 *
 * If the current location is the very first entry of this session
 * (`location.key === "default"`), there's nothing safe to pop —
 * `navigate(-1)` would either be a no-op or, worse, kick the user
 * out to whatever site they came from. In that case we route to
 * the stream root instead, which is the canonical "you've nothing
 * else queued up" home.
 */
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
export function useGoBack() {
    const navigate = useNavigate();
    const location = useLocation();
    return useCallback(() => {
        if (location.key !== "default") {
            navigate(-1);
            return;
        }
        navigate("/");
    }, [navigate, location.key]);
}
